import { MaterialCommunityIcons } from "@expo/vector-icons";
import React, {useEffect, useState} from "react";
import Constants from 'expo-constants'
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { format} from 'date-fns';
import * as Linking from 'expo-linking';
import ptBR from 'date-fns/locale/pt-BR';

import { LoadDados, LoadOneOrders } from "../services/firebaseServices";
import colors from "../styles/colors";
import { ScrollView } from "react-native";
import MyText from "../components/MyText";

const pathRefOrder = '/Order';
const pathRefBus = '/Business/Dados';
export default function OrderDetail({navigation, route}){
    const [order, setOrder] = useState(null);
    const[business, setBusiness] = useState(null)
    
    useEffect(()=>{
        const {id, key} = route.params;
        LoadOneOrders(pathRefOrder, key, response => setOrder(response));
        LoadDados(pathRefBus, response => setBusiness(response))
        
    },[])


    function renderItem(item, index){
        let _name = ''
        let cor = ''
        switch(item.status){
            case "Pendente":
                _name = 'clock-time-eight-outline'
                cor = colors.black
                break;
            case "Produção":
                _name = 'chef-hat'
                cor = colors.orange
                break;
            case 'Aguardando Retirada':
                _name = 'clock-fast'
                cor = colors.yellow
                break;
            case 'Saiu para Entrega':
                _name = 'motorbike'
                cor = colors.black
                break;
            case 'Entregue':
                _name = 'check-all'
                cor = colors.zapColor
                break;
            case 'Cancelado':
                _name = 'cancel'
                cor = colors.red
                break;
        }

        return(
            <View style={index === 0 ? [styles.containerItem,{borderTopWidth: 0}] : styles.containerItem}>
                <MyText style={styles.txtStatus}>{item.status}</MyText>
                <View style={styles.containerTime}>
                    <MaterialCommunityIcons name={_name} size={15} color={cor}/>
                    <MyText style={styles.txtTime}>{item.time}</MyText>
                </View>
            </View>
        )
    }
    function openMaps(endereco){
        const { lat, long} = endereco;
        const scheme = Platform.select({ ios: 'maps:0,0?q=', android: 'geo:0,0?q=', web: 'https://maps.google.com/?q='});
        const latLng = `${lat},${long}`;
        const url = Platform.select({
            ios: `${scheme}${latLng}`,
            android: `${scheme}${latLng}`,
            web: `${scheme}${latLng}`
        });


        Linking.openURL(url); 
    }
    function renderItemCart(value,index){
        return(
            <View style={{}} key={index}>
                <MyText style={styles.txtProduct}>{value.product}</MyText>
                <View style={styles.containerInfo}>
                    <MyText style={styles.txtInfo}>1x {value.size.name}{`\n`}</MyText>
                    <MyText style={styles.txtPriceInfo}>R$ {value.size.price}</MyText>
                </View>
                {value.flavor !== undefined && (
                    <View>
                        <MyText style={styles.txtsubTitle}>Sabor</MyText>
                        <View style={styles.containerInfo}>
                            <MyText style={styles.txtInfo}>{value.flavor.map(value => `1x ${value.name}\n`)}</MyText>
                        </View>
                    </View>
                )}
                {value.additional !== undefined && (
                    <View>
                        <MyText style={styles.txtsubTitle}>Adicionais</MyText>
                        <View style={styles.containerInfo}>
                            <MyText style={styles.txtInfo}>{value.additional.map(value => `1x ${value.name}\n`)}</MyText>
                            <MyText style={styles.txtPriceInfo}>{value.additional.map(value => `R$ ${value.price}\n`)}</MyText>
                        </View>
                    </View>
                )}
                {value.obs !== undefined && (
                <View>
                    <MyText style={styles.txtsubTitle}>Observação</MyText>
                    <MyText style={styles.txtInfo}>{value.obs}</MyText>
                </View>
                )}
            </View>
        )
    }
    return order !== null && (
        <ScrollView style={styles.container}>
            <MyText style={styles.txtTitle}>Acompanhamento</MyText>

            {order.historyStatus.map((item,index)=> renderItem(item,index))}
            <TouchableOpacity style={styles.btnContact} onPress={()=>{Linking.openURL(`https://wa.me/${business.phone}?text=Gostaria de ajuda com o pedido+%23${order.idOder}`)}}>
                <MyText style={styles.txtBtn}>{<MaterialCommunityIcons name="whatsapp" size={16}/>}   Entrar em contato</MyText>
            </TouchableOpacity>
            {order.deliveryMode === "Retirar no local" && (
                <TouchableOpacity style={styles.btnContact} onPress={()=>{openMaps(order.address)}}>
                    <MyText style={styles.txtBtn}>{<MaterialCommunityIcons name="google-maps" size={16}/>}   Ver no Mapa</MyText>
                </TouchableOpacity>
            )}

            <View style={styles.containerOrder}>
                <View style={styles.containerOrderItem}>
                    <MyText style={styles.txtOrderTitle}>{Constants.expoConfig.name}</MyText>
                    <MyText style={styles.txtHeader}>Data: {format(new Date(order.create), 'dd/MM/yyyy',{locale: ptBR})} às {order.historyStatus[0].time}</MyText>
                    <MyText style={styles.txtHeader}>Pagamento: {order.paymentMode}</MyText>
                    <MyText style={styles.txtHeader}>Tipo de serviço: {order.deliveryMode}</MyText>
                    <MyText style={styles.txtHeader}>Endereço: {order.address.rua}, {order.address.numero}, {order.address.bairro}, {order.address.referencia}</MyText>
                    <MyText style={styles.txtHeader}>** Não é um documento fiscal **</MyText>
                    <MyText style={styles.headerCart}>Itens:</MyText>
                    {order.cart.map((item,index)=> renderItemCart(item,index))}
                    <View style={[styles.containerPrice,{borderTopWidth: 1, borderTopColor: colors.gray3, marginTop: 10, paddingTop: 10}]}>
                        <MyText style={styles.txtPriceName}>Entrega</MyText>
                        <MyText style={styles.txtPrice}>R$ {order.taxaEntrega.toFixed(2).replace('.',',')}</MyText>
                    </View>
                    {order.paymentMode === 'Dinheiro' && (
                        <View style={styles.containerPrice}>
                            <MyText style={styles.txtPriceName}>Troco</MyText>
                            <MyText style={styles.txtPrice}>R$ {order.thing.toFixed(2).replace('.',',')}</MyText>
                        </View>
                    )}
                    <View style={styles.containerPrice}>
                        <MyText style={styles.txtPriceName}>Total</MyText>
                        <MyText style={styles.txtPriceTotal}>R$ {order.total.toFixed(2).replace('.',',')}</MyText>
                    </View>
                </View>
            </View>
        </ScrollView>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1
    },
    txtTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        margin: 20
    },
    containerItem: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
        paddingVertical: 20,
        backgroundColor: 'white',
        borderTopWidth: 1,
        borderTopColor: colors.gray3
    },
    txtStatus: {
        fontSize: 15
    },
    containerTime: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    txtTime: {
        fontSize: 15,
        marginLeft: 5
    },
    btnContact: {
        width: 200,
        height: 40,
        borderWidth: 1,
        borderRadius: 5,
        borderColor: colors.red,
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
        marginTop: 20
    },
    txtBtn: {
        fontSize: 15,
        color: colors.red,
        fontWeight: 'bold'
    },
    // Order
    containerOrder: {
        backgroundColor: 'white',
        padding: 20,
        marginTop: 10
    },
    containerOrderItem: {
        backgroundColor: colors.yellow2,
        padding: 10,
        borderRadius: 5
    },
    txtOrderTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        alignSelf: 'center',
        marginVertical: 10
    },
    txtHeader: {
        fontSize: 13,
        marginHorizontal: 30,
        alignSelf: 'center',
        textAlign: 'center'
    },
    headerCart: {
        fontSize: 14,
        fontWeight: 'bold',
        borderBottomWidth: 1,
        borderBottomColor: colors.gray3,
        marginBottom: 5
    },
    // cart
    txtProduct: {
        fontSize: 14
    },
    containerInfo: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: 10
    },
    txtInfo: {
        fontSize: 13
    },
    txtPriceInfo: {
        fontSize: 13
    },
    txtsubTitle: {
        fontSize: 14
    },
    containerPrice: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingRight: 10,
        marginBottom: 10
    },
    txtPriceName: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    txtPrice: {
        fontSize: 14
    },
    txtPriceTotal: {
        fontSize: 14,
        fontWeight: 'bold'
    }
})